import React from "react";

const CloseIcon: React.FC<{ className?: string; color?: string }> = ({
  className,
  color = "#3D3D3D", // Default color is #3D3D3D
}) => (
  <svg
    className={className}
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.3125 2.39941L10.7119 8L16.3125 13.6006L14.1006 15.8125L8.5 10.2119L2.89941 15.8125L0.6875 13.6006L6.28809 8L0.6875 2.39941L2.89941 0.1875L8.5 5.78809L14.1006 0.1875L16.3125 2.39941Z"
      fill={color}
    />
  </svg>
);

export default CloseIcon;
